import {Pipe, PipeTransform} from "@angular/core";
import {WherePipe} from "./where.pipe";

@Pipe({
  name: 'whereNot',
  standalone: true
})
export class WhereNotPipe implements PipeTransform {
  constructor(private wherePipe: WherePipe) {
  }

  transform<T>(inputs: T[], prop: string, search?: any, strict?: boolean): T[] {
    return this.wherePipe.transform(inputs, prop, search, strict, true)
  }
}
